import { useCallback } from "react";
import { PublicConfig } from "apps/website/config/public";
import { useGA } from "apps/website/hooks/useGA";

const NEWSLETTER_SUBSCRIBE_URL = `${PublicConfig.NEXT_PUBLIC_OLD_API_BASE_URL}/subscribeToNewsletter`;

const SUBSCRIBED_WITHOUT_EXTRA_DATA_STATUS = 504;

export function useNewsletterSubscribe(source?: string) {
  const trackEvent = useGA();

  return useCallback(async (email: string) => {
    trackEvent({
      category: "NEWSLETTER_SIGNUP",
      action: "EMAIL_SUBMITTED",
      value: email,
      label: `Source: ${source}`,
    });

    const response = await fetch(NEWSLETTER_SUBSCRIBE_URL, {
      method: "POST",
      body: JSON.stringify({ data: { email, source } }),
    });

    if (!response.ok && response.status !== SUBSCRIBED_WITHOUT_EXTRA_DATA_STATUS) {
      throw new Error(`Newsletter signup failed with status ${response.status}`);
    }
  }, [ source, trackEvent ]);
}
